import React from "react";
import { useNavbarContext } from "../Navbar";
import { NavItemProps } from "../../types";
import styles from './NavLink.module.scss';
import classNames from "classnames";

interface NavLinkProps {
  item: NavItemProps;
  onMouseOver?: () => void,
  onMouseLeave?: () => void,
  isWithStyle?: boolean;
  isSelected?: boolean;
  isDesktop?: boolean,
  parentHasDropdown?: boolean;
  level: number;
}

export const NavLink = (props: NavLinkProps) => {
  const { item, onMouseOver, onMouseLeave, isWithStyle = false, isSelected = false, isDesktop = false, parentHasDropdown = false, level } = props;
  const { linkComponent } = useNavbarContext();

  if(!linkComponent && item.type !== 'spa') {
    return (
      <LinkElement
        item={item}
        isWithStyle={isWithStyle}
        isSelected={isSelected}
        isDesktop={isDesktop}
        parentHasDropdown={parentHasDropdown}
        level={level}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      />
    )
  }

  return linkComponent(
    <LinkElement
      item={item}
      isWithStyle={isWithStyle}
      isSelected={isSelected}
      isDesktop={isDesktop}
      parentHasDropdown={parentHasDropdown}
      level={level}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    />,
    item
  );
}

const LinkElement = (props: NavLinkProps) => {
  const { item, onMouseOver, onMouseLeave, isWithStyle, isSelected = false, isDesktop = false, parentHasDropdown = false, level } = props;

  var itemClass:string;

  const switchClass = ( level:number ) => {
    switch(level) {
      case 0:
        itemClass = 'primary_nav_link';
        break;

      case 1:
        itemClass = 'secondary_nav_link';
        break;

      case 2:
        itemClass = 'tertiary_nav_link';
        break;

      default:
        itemClass = '';
    }

    return itemClass;
  }

  return (
    parentHasDropdown ? (
      <a
        href = {isDesktop ?  item.link : null }
        title = {item.title}
        className = {classNames(
          styles[switchClass(level)],
          isSelected && styles['selected'],
        )}
        onTouchEnd = {isDesktop ? null : (isSelected ? onMouseLeave : onMouseOver)}
        onMouseOver = {isDesktop ? onMouseOver : null }
      >
        
        <span>{item.title}</span>

        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path d="M8.55553 9.98334C8.46664 9.98334 8.38064 9.96667 8.29753 9.93334C8.21398 9.9 8.14442 9.85556 8.08887 9.8L5.0222 6.73334C4.89998 6.61111 4.83887 6.45556 4.83887 6.26667C4.83887 6.07778 4.89998 5.92222 5.0222 5.8C5.14442 5.67778 5.29998 5.61667 5.48887 5.61667C5.67776 5.61667 5.83331 5.67778 5.95553 5.8L8.55553 8.4L11.1555 5.8C11.2778 5.67778 11.4333 5.61667 11.6222 5.61667C11.8111 5.61667 11.9666 5.67778 12.0889 5.8C12.2111 5.92222 12.2722 6.07778 12.2722 6.26667C12.2722 6.45556 12.2111 6.61111 12.0889 6.73334L9.0222 9.8C8.95553 9.86667 8.88331 9.91378 8.80553 9.94134C8.72776 9.96934 8.64442 9.98334 8.55553 9.98334Z" />
        </svg>
      </a>

    ) : (
      <a
        href = {item.link}
        title = {item.title}
        className = {classNames(
          styles[switchClass(level)],
          isSelected && styles['selected'],
        )}
        onClick = {(e) => {
          if (item.type === 'prevent' || item.type === 'spa') {
            e.preventDefault();
          }
          item.onClick && item.onClick(item);
        }}
      >
        
        <span>{item.title}</span>
      </a>
    )
  );
}